import getConfig from "config";

export function linkToPageNotFoundError() {
  return "/not-found";
}

export function getLinkToPlurallStore() {
  return getConfig().plurall.linkToPlurallStore;
}
